import React, { useEffect, useMemo, useState } from 'react';
import {
  Dropdown,
  DropdownOverlay,
  AutoComplete,
  ActionList,
  ActionListItem,
  Box,
  Spinner,
  Text,
} from '@razorpay/blade/components';
import { CustomSelectInputProps } from '../types';
import { useQuery } from 'react-query';
import api from 'api';
import { statesOfIndia } from 'utils/StatesOfIndia';

export const SelectDispensary = ({ register, formData }: CustomSelectInputProps) => {
  const [searchValue, setSearchValue] = useState('');
  const selectedState =
    statesOfIndia.find((s) => s.code.toString() === formData?.state?.[0])?.esicState || '';

  const selectedDispensary = formData?.esicDispensary?.[0];

  const selectedDistrict = formData?.district?.[0];

  const { data, isLoading, isFetching } = useQuery({
    queryKey: ['dispensary', selectedState, selectedDistrict],
    queryFn: () =>
      api.officeLocation.fetchDispensaryForDistrict({
        state: selectedState,
        district: selectedDistrict!,
      }),
    enabled: !!selectedState && !!selectedDistrict,
  });

  const filteredDispensaries = useMemo(() => {
    return (
      data?.filter((dispensary) =>
        searchValue ? dispensary.toLowerCase().includes(searchValue.toLowerCase()) : true,
      ) || []
    );
  }, [data, searchValue]);

  useEffect(() => {
    setSearchValue(selectedDispensary || '');
  }, [selectedDispensary]);

  return (
    <Dropdown
      selectionType="single"
      onOpenChange={(isOpen) => {
        if (!isOpen && selectedDispensary) {
          setSearchValue(selectedDispensary);
        } else {
          setSearchValue('');
        }
      }}>
      <AutoComplete
        label="ESIC Dispensary"
        placeholder="Search ESIC Dispensary"
        inputValue={searchValue || ''}
        onInputValueChange={({ value }) => {
          setSearchValue(value || '');
        }}
        filteredValues={filteredDispensaries}
        {...register({ name: 'esicDispensary', type: 'select' })}
      />
      <DropdownOverlay>
        {isLoading || isFetching ? (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            gap="spacing.5"
            padding="spacing.5">
            <Spinner accessibilityLabel="loading states" />
          </Box>
        ) : filteredDispensaries?.length ? (
          <ActionList>
            {filteredDispensaries?.map((dispensary, idx) => (
              <ActionListItem
                key={idx + dispensary}
                title={dispensary}
                value={dispensary}
                isSelected={selectedDispensary === dispensary}
              />
            ))}
          </ActionList>
        ) : (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            gap="spacing.5"
            padding="spacing.5">
            <Box display="flex" flexDirection="column" gap="spacing.3">
              <Text size="medium" weight="semibold" textAlign="center">
                No Dispensaries Found
              </Text>
            </Box>
          </Box>
        )}
      </DropdownOverlay>
    </Dropdown>
  );
};
